/**
 * Årgangsinnstillingenes fire faner, som verdier.
 *
 * Egen fil av samme grunn som `people-tabs.ts`: ruta validerer `?tab=` i kanten, og en import fra
 * sidekomponenten ville dratt hele siden inn i ruterens hovedbunt.
 */
export const EDITION_SETTINGS_TAB_IDS = [
  'general',
  'departments',
  'personFields',
  'economy',
] as const;
export type EditionSettingsTabId = (typeof EDITION_SETTINGS_TAB_IDS)[number];
